import authService from "src/services/authService";
export const permissionCheck = permissionName => {
  let check = authService.hasPermission(permissionName);
  return check;
};
